import { isPc } from '../_utils/platform';
export const convertType = (type) => {
    if (type === 'number') {
        if (isPc()) {
            return type;
        }
        else {
            return 'tel';
        }
    }
    return type;
};
export const convertValue = (value) => {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
};
